import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 48px;
  padding-top: 40px;

  @media ${device.isTabletAndAbove} {
    border-top: 2px solid ${colors.darkGrey10};
  }
`;
